import { checkIsAndroid, checkIsIOS, checkIsIPadOS, checkIsMobileOS, detectDesktopOS, detectHighConfidenceOS, detectLinuxOrAndroid, detectLinuxPlatform, mapPlatformToOS, } from "./deviceDetectionUtils";
import { classifyIOS, classifyAndroid, classifyFallback, getNavPlatform, } from "./deviceDetectionUtils";
export const CSS_CLASS_PREFIX = "tm-env__client";
export const CSS_CLASS_SUFFICES = {
    os: "os",
};
const detectOSFromUserAgent = () => {
    const { userAgent } = navigator;
    const highConfidenceResult = detectHighConfidenceOS(userAgent);
    if (highConfidenceResult) {
        return highConfidenceResult;
    }
    const desktopResult = detectDesktopOS(userAgent, getNavPlatform());
    if (desktopResult) {
        return desktopResult;
    }
    if (/Linux/i.test(userAgent)) {
        return detectLinuxOrAndroid();
    }
    return "Unknown";
};
const detectOSFromUserAgentData = () => {
    const platformRaw = navigator.userAgentData?.platform || "";
    if (platformRaw === "macOS" && navigator.maxTouchPoints > 1) {
        return "iOS";
    }
    const platform = platformRaw.trim().toLowerCase();
    const ua = navigator.userAgent || "";
    if (platform.includes("linux")) {
        return detectLinuxPlatform(ua);
    }
    return mapPlatformToOS(platform);
};
export const detectOS = () => {
    const userAgentDataOSName = detectOSFromUserAgentData();
    if (userAgentDataOSName !== "Unknown") {
        return userAgentDataOSName;
    }
    return detectOSFromUserAgent();
};
export const detectDeviceType = (OSName) => {
    if (typeof navigator === "undefined") {
        return "unknown";
    }
    const os = (OSName || detectOS()).toLowerCase();
    if (checkIsIPadOS()) {
        return "tablet";
    }
    if (os === "ios") {
        return classifyIOS();
    }
    if (os === "android") {
        const uaDataMobile = navigator.userAgentData?.mobile;
        return classifyAndroid(uaDataMobile);
    }
    return classifyFallback();
};
export const getOSData = () => {
    const OSName = detectOS();
    const deviceType = detectDeviceType(OSName);
    return {
        OSName,
        isMobileOS: checkIsMobileOS(OSName),
        isAndroid: checkIsAndroid(OSName),
        isIOS: checkIsIOS(OSName),
        isTablet: deviceType === "tablet",
        isPhone: deviceType === "phone",
        deviceType,
    };
};
